import { selectBuildingsWhichProducesResourceIdAvailable } from "../selectors/selectBuildingsWhichProducesResourceIdAvailable";
export var checkAnyBuildingWhichProducesResourceIdAvailable = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var availableBuildings = selectBuildingsWhichProducesResourceIdAvailable(state, action.taskType.resourceId);
    return availableBuildings.length ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/checks/checkAnyBuildingWhichProducesResourceIdAvailable.ts
// module id = 894
// module chunks = 3